// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class DisconnectPreventionMessageConstants {
    static AppMessage = 'Please Note: Please avoid minimizing or switching to other applications during our chat session, as this may disconnect us.';
    static BrowserMessage = 'Please Note: To keep our chat session connected, please do not refresh, minimize or hit the back button on your browser.';
}